import { defineQuery, useQuery } from '@pinia/colada'
import { api } from '~/services/composition'

export const useCurrentUserQuery = defineQuery(() =>
  useQuery({
    key: () => ['current-user'],
    enabled: false,
    query: () => api.user.getCurrentUser()
  })
)
